import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { getGroups } from '../api/groups';
import { GroupInterface } from '../types';

interface GroupSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

function GroupSelect({ value, onChange, label = 'Group', disabled }: GroupSelectProps): React.JSX.Element {
  const [groups, setGroups] = useState<GroupInterface[]>([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    setDropdownLoading(true);
    try {
      const res = await getGroups();
      const groupsData: GroupInterface[] = res.data || [];
      setGroups(groupsData);
    } finally {
      setDropdownLoading(false);
    }
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="group-select-label">{label}</InputLabel>
      <Select
        labelId="group-select-label"
        value={value}
        label={label}
        onChange={e => onChange(e.target.value)}
        disabled={disabled || dropdownLoading}
      >
        <MenuItem value="">
          <em>בחר קבוצה</em>
        </MenuItem>
        {groups.map(group => (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        ))}
      </Select>
      {(dropdownLoading) && <CircularProgress size={20} sx={{ position: 'absolute', right: 8, top: 8 }} />}
    </FormControl>
  );
}

export default GroupSelect; 